<template>
  <v-alert type="warning" prominent border="left" class="mb-4">
    <v-row align="center">
      <v-col class="grow">
        <div class="text-h6 mb-2">
          <v-icon left color="warning">mdi-rss</v-icon>
          RSS Feed Limit Reached
        </div>
        <div>
          You've reached the free limit of {{ rssLimit }} RSS feed items. To
          load more RSS feeds, please upgrade to any premium plan for unlimited
          access.
        </div>
      </v-col>
      <v-col class="shrink">
        <v-btn color="primary" to="/subscriptions"> Upgrade Now </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: 'RssUpgradeAlert',
  computed: {
    rssLimit() {
      return parseInt(process.env.VUE_APP_RSS_LIMIT) || 50
    }
  }
}
</script>
